<template>
  <vs-popup id="popupExcelDownloadViewer" title="선택 후 엑셀다운로드" :active.sync="showPopup">
    <div class="popup-excel-download-viewer">
      <div class="w-full overflow-x-auto" v-if="showPopup">
        <table-list-page
          :board-id="boardId"
          :board-slug="`board-${boardId}`"
          :download="false"
          :create="false"
          :approval="isApproval"
          :move-project="false"
          :move-detail="false"
          :nav="popupNav"
          :heads="heads"
          :getCol="getCol"
          :query-search-mode="false"
          :select-list="printDatas"
          selectType="ExcelDownload"
          selectListActionLabel="선택된 문서 엑셀다운로드"
          @load="onLoadData"
          @detail="onClickDetail"
          @selectAll="onSelectAll"
          @selectAction="onClickExcelDownload"
        >
          <template #search>
            <component :is="searchComponent" :value="popupNav.value" @input="onChangeSearch" />
          </template>
        </table-list-page>
      </div>
    </div>
  </vs-popup>
</template>

<script>
import draggable from "vuedraggable";
import SearchNav from "@/components/nav/SearchNav";
import tabItems from "@/views/boards/tab/tab-items";
import singlePageList from "@/views/boards/single-page/listIndex";
import TableListPage from "@/views/list/TableListPage";
import singlePageWrite from "@/views/boards/single-page/writeIndex";
import ExcelJS from "exceljs";
export default {
  components: { TableListPage, SearchNav, draggable },
  props: {
    value: Boolean,
    isApproval: Boolean,
    boardId: [Number, String],
    searchComponent: Object,
    nav: Object,
    method: Object,
  },
  computed: {
    showPopup: {
      get() {
        return this.value;
      },
      set(value) {
        if (!value) {
          this.printDatas = [];
        }
        this.$emit("input", value);
      },
    },

    componentWrite() {
      return singlePageWrite[`${this.boardId}_write`];
    },

    heads() {
      if (singlePageList[`${this.boardId}_list`]) {
        return singlePageList[`${this.boardId}_list`].getHead();
      }
      return [];
    },
  },
  watch: {
    nav(value) {
      this.popupNav = value;
    },
  },
  data() {
    return {
      tabItems,
      printDatas: [],
      isPrint: false,
      popupNav: {
        projectId: 0,
        orderTarget: "created_at",
        orderDirection: "desc",
        date: { year: new Date().getFullYear(), month: "" },
        value: {},
        page: {},
        keyword: [],
      },
    };
  },
  methods: {
    getCol(index, value) {
      if (singlePageList[`${this.boardId}_list`]) {
        return singlePageList[`${this.boardId}_list`].getCol(index, value, {
          getContent: this.method.getContent,
          getCreatedDate: this.method.getCreatedDate,
          getCompanyName: this.method.getCompanyName,
          getContentTargetList: this.method.getContentTargetList,
          onNameBlur: this.method.onNameBlur,
          getContentRiskList: this.method.getContentRiskList,
          getContentStringList: this.method.getContentStringList,
          comma: this.method.comma,
        });
      }
      return "";
    },
    getContent(data) {
      if (data.post_content) {
        const content = JSON.parse(data.post_content);
        return content;
      }
    },

    handleClickClose() {
      this.showPopup = false;
    },

    onChangeSearch(value) {
      this.popupNav.value = value;
    },

    onLoadData(data) {},

    async onSelectAll(list) {
      for (const row of list) {
        if (this.printDatas.filter((post) => post.id === row.raw.id).length === 0) {
          this.printDatas.push(row.raw);
        }
      }
    },
    onClickDetail(data) {
      const boardId = this.boardId;
      const postId = data.postId;
      const findIndex = this.printDatas.findIndex((item) => item.id === postId);
      if (findIndex > -1) {
        this.onClickDelete(findIndex, postId);
        return;
      }

      if (this.isApproval) {
        this.loadApprovalPost(`board-${boardId}`, postId);
      } else {
        this.loadBoardPost(boardId, postId);
      }
    },

    onClickDelete(id, postId) {
      this.printDatas.splice(id, 1);
    },

    async loadBoardPost(boardId, postId) {
      await this.$store.dispatch("board/LOAD_POST", {
        boardId,
        postId,
      });

      // 내용
      const post = this.$store.state.board.postInfo;
      this.docProjectId = post.project_id;

      if (post.post_content) {
        const form = JSON.parse(post.post_content);
        if (!form.body["fileList"]) {
          form.body.fileList = [];
        }
        if (!form.body["formList"]) {
          form.body.formList = [];
        }
        form.body.createdAt = post.created_at;

        this.printDatas.push(post);
      }
    },
    async loadApprovalPost(boardSlug, postId) {
      let post = {};
      await this.$store.dispatch("approval/LOAD_POST", { boardSlug, postId }).then((value) => {
        post = value.post;
        this.docProjectId = post.id;
        return value;
      });

      if (!this.$store.state.approval.postInfo) {
        alert("열람 권한이 없습니다.");
        this.oldForm = JSON.parse(JSON.stringify(this.form));
        this.onMoveNormalPage("list");
        return;
      }
      // 내용
      if (post.post_content) {
        let form = JSON.parse(post.post_content);

        if (!form.body["fileList"]) {
          form.body.fileList = [];
        }
        if (!form.body["formList"]) {
          form.body.formList = [];
        }

        // enc 내용을 본문에 추가하기
        // form = this.loadApprovalPostContent(form);
        // this.form = form;
      }

      // TODO : 결재프로세스
      const doc = this.$store.state.approval.document;
      this.docInfo = doc;
      this.docInfo.slug = this.boardSlug;

      this.printDatas.push(post);
    },

    async onClickExcelDownload() {
      if (!singlePageList[`${this.boardId}_list`]) return false;

      const excelInfo = singlePageList[`${this.boardId}_list`].excelInfo(this.printDatas);

      // 엑셀 파일 가져오기
      // 파일은 public/fms/ 경로에 저장되어 있다.
      const response = await fetch(excelInfo.filePath);
      const arrayBuffer = await response.arrayBuffer();

      for (const data of this.printDatas) {
        const workbook = new ExcelJS.Workbook();
        await workbook.xlsx.load(arrayBuffer);

        // 첫번째 시트의 이름 가져오기
        const baseWorksheet = workbook.worksheets[0];

        let worksheetName = `${data.id}-${excelInfo.worksheetName(JSON.parse(data.post_content))}`;

        const worksheet = workbook.addWorksheet();
        worksheet.model = Object.assign(baseWorksheet.model, {
          name: worksheetName,
        });
        baseWorksheet.eachRow((row, rowNumber) => {
          const newRow = worksheet.getRow(rowNumber);
          row.eachCell((cell, colNumber) => {
            const newCell = newRow.getCell(colNumber);
            for (const prop in cell) {
              //newCell[prop] = cell[prop];
            }
            newCell.style.border.bottom = { style: "hair", color: { indexed: 64 } };
            newCell.alignment = { horizontal: "center", vertical: "middle", wrapText: true };
          });
          row.alignment = { horizontal: "center", vertical: "middle", wrapText: true };
        });

        await excelInfo.applyDataToSheet(worksheet, JSON.parse(data.post_content), {
          addImage: async (hashedName, range) => {
            const ext = hashedName.split(".")[1];
            await this.$store.dispatch("file/FILE_DOWNLOAD", { hashedName }).then(async (response) => {
              const imageId = workbook.addImage({
                base64: await blobToString(response),
                extension: ext,
              });
              worksheet.addImage(imageId, range);
            });
          },
          getMerges: () => {
            return baseWorksheet.model.merges;
          },
          setMerges: (merges) => {
            for (const merge of merges) {
              worksheet.unMergeCells(merge);
              worksheet.mergeCells(merge);
            }
          },
        });

        // 템플릿으로 사용한 첫번째 시트 삭제
        workbook.removeWorksheet(1);

        async function blobToString(blob) {
          return new Promise((resolve, reject) => {
            const reader = new FileReader();
            reader.onerror = reject;
            reader.onload = () => {
              resolve(reader.result);
            };
            reader.readAsDataURL(blob);
          });
        }

        const buffer = await workbook.xlsx.writeBuffer();
        const blob = new Blob([buffer], { type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" });

        let fileName = `${excelInfo.downloadFileName}_${data.id}.xlsx`;
        const url = window.URL.createObjectURL(blob);
        const a = document.createElement("a");
        a.href = url;
        a.download = fileName;
        document.body.appendChild(a);
        a.click();
        window.URL.revokeObjectURL(url);
      }
    },
  },
};
</script>
<style scoped lang="scss">
.popup-excel-download-viewer {
  display: grid;
  /* grid-template-columns: 1fr 270px; */
}
</style>
<style lang="scss">
#popupExcelDownloadViewer.con-vs-popup {
  z-index: 53000;

  .vs-popup {
    width: 1300px !important;
    height: auto;

    position: relative;
  }
  .vs-popup--content {
    width: auto !important;
    padding: 1rem;
    font-size: 1rem;
  }
}

#subCard {
  .vx-card__collapsible-content.vs-con-loading__container,
  .vx-card__collapsible-content.vs-con-loading__container > .vx-card__body {
    height: 100%;
  }
}

.print-card {
  display: grid;
  grid-template-columns: 16px 1fr;

  -ms-user-select: none;
  -moz-user-select: -moz-none;
  -khtml-user-select: none;
  -webkit-user-select: none;
  user-select: none;

  .handle {
    border-top-left-radius: 10px;
    border-bottom-left-radius: 10px;
    background: rgba(var(--vs-secondary), 1);
  }
}
.print-card-body {
  padding-left: 0.75rem;
  font-size: 0.8rem;
}
</style>
